
export default {
  path: '/assets',
  redirect: { name: 'assets' },
  component: () => import('@/pages/s'),
  children: [
    // 资产主页
    {
      path: 'index',
      name: 'assets',
      component: () => import('@/pages/assets/index')
    },
    // 充值
    {
      path: 'recharge',
      name: 'recharge',
      component: () => import('@/pages/assets/recharge')
    },
    // 提现
    {
      path: 'withdraw',
      name: 'withdraw',
      component: () => import('@/pages/assets/withdraw')
    },
    //资金记录
    {
      path: 'moneyRecord',
      name: 'moneyRecord',
      component: () => import('@/pages/assets/moneyRecord')
    },
    //信用周转
    {
      path: 'creditCycle',
      name: 'creditCycle',
      component: () => import('@/pages/assets/creditCycle')
    },
    //域名管理
    {
      path: 'domainManage',
      name: 'domainManage',
      component: () => import('@/pages/assets/domainManage'),
      children: [
        // 批量质押
        {
          path: 'batchPledge',
          name: 'batchPledge',
          component: () => import('@/pages/assets/batchPledge'),
        },
        // 批量解除质押
        {
          path: 'batchRemove',
          name: 'batchRemove',
          component: () => import('@/pages/assets/batchRemove'),
        }
      ]
    },
    //注册商管理
    {
      path: 'registrarManage',
      name: 'registrarManage',
      component: () => import('@/pages/assets/registrarManage')
    },
    //批量移除
    {
      path: 'batchRemove',
      name: 'batchRemove',
      component: () => import('@/pages/assets/batchRemove'),
    },
    //批量质押
    {
      path: 'batchPledge',
      name: 'batchPledge',
      component: () => import('@/pages/assets/batchPledge'),
    },
    //申请授信
    {
      path: 'applyCredit',
      name: 'applyCredit',
      component: () => import('@/pages/assets/applyCredit'),
    }
  ]
}